var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M5.55953 20.4L11.5995 26.44C14.0795 28.92 18.1062 28.92 20.5995 26.44L26.4529 20.5867C28.9329 18.1067 28.9329 14.08 26.4529 11.5867L20.3995 5.56C19.1329 4.29334 17.3862 3.61334 15.5995 3.70667L8.93286 4.02667C6.2662 4.14667 4.1462 6.26667 4.01286 8.92L3.69286 15.5867C3.61286 17.3867 4.29286 19.1333 5.55953 20.4Z",
    fill: "#FF403D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6671 16.5067C14.7879 16.5067 16.5071 14.7874 16.5071 12.6667C16.5071 10.5459 14.7879 8.82666 12.6671 8.82666C10.5464 8.82666 8.82715 10.5459 8.82715 12.6667C8.82715 14.7874 10.5464 16.5067 12.6671 16.5067Z",
    fill: "#FF403D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3336 23.6667C17.0802 23.6667 16.8269 23.5733 16.6269 23.3733C16.2402 22.9867 16.2402 22.3467 16.6269 21.96L21.9602 16.6267C22.3469 16.24 22.9869 16.24 23.3736 16.6267C23.7602 17.0133 23.7602 17.6533 23.3736 18.04L18.0402 23.3733C17.8402 23.5733 17.5869 23.6667 17.3336 23.6667Z",
    fill: "#FF403D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.d090782a71488d39994f6402b45786fc.svg";
export { ForwardRef as ReactComponent };